import React, { Component } from "react";
import {
  MDBNavbar,
  MDBContainer,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBIcon,
} from "mdb-react-ui-kit";
import { BrowserRouter as Router } from "react-router-dom";

class NavbarPage extends Component<any, any> {
  state = {
    showNav: false,
  };

  toggleNavbar = () => {
    this.setState({ showNav: !this.state.showNav });
  };

  render() {
    return (
      <Router>
      <MDBNavbar expand="md" dark className="default-color">
          <MDBContainer fluid>
           
            <MDBNavbarToggler
              type="button"
              aria-label="Toggle navigation"
              onClick={this.toggleNavbar}
            >
              <MDBIcon icon="bars" fas />
            </MDBNavbarToggler>

            <MDBCollapse navbar open={this.state.showNav}>
              <MDBNavbarNav className="mr-auto">
                {this.props.roleStatus && (
                  <MDBNavbarItem>
                    <MDBNavbarLink
                      href="/configuration-listing"
                      className="nav-link"
                    >
                      Configuration
                    </MDBNavbarLink>
                  </MDBNavbarItem>
                )}

                <MDBNavbarItem>
                  <MDBDropdown>
                    <MDBDropdownToggle
                      tag="a"
                      className="nav-link"
                      role="button"
                      caret
                    >
                      <div
                        className="d-none d-md-inline"
                        style={{ fontSize: "11px" }}
                      >
                        Vehicle
                      </div>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu>
                      <MDBDropdownItem link href="/device-listing">
                        Listing
                      </MDBDropdownItem>
                      <MDBDropdownItem link href="/device-onboarding">
                        Onboarding
                      </MDBDropdownItem>
                      <MDBDropdownItem link href="/bulk-upload">
                        Bulk Upload
                      </MDBDropdownItem>
                      <MDBDropdownItem link href="/payload-form">
                        Payload Form
                      </MDBDropdownItem>
                      <MDBDropdownItem link href="/json-form">
                        JSON Form
                      </MDBDropdownItem>
                      <MDBDropdownItem link href="/logs">
                        Simulator Logs
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavbarItem>
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </MDBNavbar>
      </Router>
    );
  }
}

export default NavbarPage;
